// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"95ab076b","453":"f2c1f545","455":"110d011f","977":"19de5fa4"}[chunkId] + ".chunk.js";
};